/**
 * Bus analytics (GTM/ecommerce) için yardımcı fonksiyonlar.
 * Rezervasyon sayfası ve ödeme adımında ortak kullanılır.
 */

export const formatTime = (dateString) => {
  try {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
};

export const formatDate = (dateString) => {
  try {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  } catch {
    return "";
  }
};

/**
 * Basket product'ından ecommerce item objesi oluşturur.
 * @param {Object} product - Basket'ten gelen product (Segments, Tickets vb.)
 * @param {number} index - Item index
 * @param {Object} options - coupon, pricePerItem, item_list_id, item_list_name, ticketId, quantity, discount
 */
export const buildItemFromProduct = (
  product,
  index,
  {
    coupon = "",
    pricePerItem = 0,
    item_list_id = "Search_List",
    item_list_name = "Search List",
    ticketId = null,
    quantity = 1,
    discount = 0,
  } = {}
) => {
  const segments = product?.Segments ?? [];
  const firstSegment = segments[0] ?? {};
  const lastSegment = segments[segments.length - 1] ?? firstSegment;

  const origin = firstSegment?.Origin ?? "";
  const destination = lastSegment?.Destination ?? "";
  const busCompany =
    typeof firstSegment?.BusCompany === "string"
      ? firstSegment.BusCompany
      : firstSegment?.BusCompany?.Name ?? firstSegment?.BusCompany?.CompanyName ?? "";

  return {
    item_id: `${origin}-${destination}`.replace(/\s+/g, "-") || "bus",
    item_name: "bus",
    ...(ticketId != null && ticketId !== "" ? { ticket_id: String(ticketId) } : {}),
    affiliation: "turna.com",
    coupon: coupon || "",
    discount: Number(discount) || 0,
    index,
    item_brand: busCompany || "",
    item_category: "bus",
    item_category2: firstSegment?.IsDomestic ? "domestic" : "international",
    origin: origin || "",
    destination: destination || "",
    departure_time: formatTime(firstSegment?.DepartureTime) || "",
    start_date: formatDate(firstSegment?.DepartureTime) || "",
    item_list_id,
    item_list_name,
    price: pricePerItem,
    quantity: quantity ?? 1,
  };
};
